import { components, paths } from "@api/api";
import { useSelector } from "react-redux";
import { currentCountrySelector } from "@selectors/countries.selector";
import useAxios from "@hooks/useFetch";

const REQUEST_URL: keyof paths = '/InstantCharts/Data/{countryCode}/{instantChartId}';
export type Response = components["schemas"]["Application.Byo.Models.ByoFilterAndResult"];

export function useInstantChart(id: number | null) {
    const countryCode = useSelector(currentCountrySelector);

    const url = REQUEST_URL
        .replace('{countryCode}', countryCode)
        .replace('{instantChartId}', (id ?? 0).toString())
    ;

    return useAxios<Response>({
        url,
        method: 'get',
        lazy: id === null,
    });

}